import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const ProductionChainStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "production-chain",
})`
  .production-chain-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .production-chain-title {
    font-size: 0.875rem;
    font-weight: 500;
    color: ${greyMui._700};
    margin: 0;
  }
`;
